import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import TaskInvoicesModal from './TaskInvoicesModal';
import useTaskChargeInvoices from './useTaskChargeInvoices';
import { getTaskById } from '../../../store/actions/picker.action';

// Task list "Invoice" action: loads the task's posted charges and lists their invoices.
const TaskListingInvoicesModal = ({ taskRow, handleCancel }) => {
    const [task, setTask] = useState(null);
    const [loadingTask, setLoadingTask] = useState(true);
    const { invoices, loading } = useTaskChargeInvoices(task, Boolean(task), taskRow.companySellerName);

    useEffect(() => {
        let active = true;
        getTaskById(taskRow.id)
            .then((response) => {
                if (active && response?.data?.Status === 200) setTask(response.data.Entity);
            })
            .catch((error) => console.error('Failed to load task for invoices', error))
            .finally(() => {
                if (active) setLoadingTask(false);
            });
        return () => {
            active = false;
        };
    }, [taskRow.id]);

    return (
        <TaskInvoicesModal
            show
            handleCancel={handleCancel}
            taskId={taskRow.id}
            taskTitle={taskRow.taskTitle}
            invoices={invoices}
            loading={loadingTask || loading}
        />
    );
};

TaskListingInvoicesModal.propTypes = {
    taskRow: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        taskTitle: PropTypes.string,
        companySellerName: PropTypes.string,
    }).isRequired,
    handleCancel: PropTypes.func.isRequired,
};

export default TaskListingInvoicesModal;
